import React, { useState } from 'react';
import { FeatureFlag } from '../types';
import {
  Box,
  Button,
  DialogActions,
  Switch,
  TextField,
} from '@material-ui/core';
import { stringifyEntityRef, SystemEntity } from '@backstage/catalog-model';
import { TagsInput } from './TagsInput';

export const NewFeatureFlagCard = ({
  system,
  onCreate,
}: {
  system: SystemEntity;
  onCreate: (flag: FeatureFlag) => void;
}) => {
  const [newFeatureFlag, setNewFeatureFlag] = useState<FeatureFlag>({
    code: '',
    description: '',
    state: 'ACTIVE',
    tags: [],
    system: stringifyEntityRef(system),
    wasUpdated: true,
    wasSearched: true,
    wasCreated: true,
  });

  const handleInputChange = (
    field: keyof FeatureFlag,
    value: string | boolean,
  ) => {
    setNewFeatureFlag(prev => ({ ...prev, [field]: value }));
  };

  const handleAddFeatureFlag = () => {
    onCreate(newFeatureFlag);
  };

  const isFormValid = () => {
    return (
      newFeatureFlag.code.trim() !== '' &&
      newFeatureFlag.description.trim() !== ''
    );
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9_]/g, '')
      .replace(/\s+/g, '_');
    handleInputChange('code', value);
  };

  const handleStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleInputChange('state', event.target.checked ? 'ACTIVE' : 'INACTIVE');
  };

  return (
    <Box display="flex" flexDirection="column" width={400} mb={1}>
      <Box display="flex" flexDirection="column" padding={1} gridRowGap={16}>
        <TextField
          label="Code"
          variant="outlined"
          value={newFeatureFlag.code}
          onChange={handleCodeChange}
          inputProps={{ maxLength: 255 }}
          required
        />
        <TextField
          label="Description"
          variant="outlined"
          value={newFeatureFlag.description}
          onChange={e => handleInputChange('description', e.target.value)}
          multiline
          rows={4}
          inputProps={{ maxLength: 4000 }}
          required
        />
        <TagsInput
          tags={newFeatureFlag.tags ?? []}
          onChange={tags => setNewFeatureFlag(prev => ({ ...prev, tags }))}
        />
        <Box display="flex" alignItems="center">
          <Switch
            color="secondary"
            checked={newFeatureFlag.state === 'ACTIVE'}
            onChange={handleStateChange}
          />
          <h3>{newFeatureFlag.state === 'ACTIVE' ? 'Enabled' : 'Disabled'}</h3>
        </Box>
      </Box>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddFeatureFlag}
          disabled={!isFormValid()}
        >
          Add feature flag
        </Button>
      </DialogActions>
    </Box>
  );
};
